import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { HttpClient } from '@angular/common/http';
import { map, catchError } from 'rxjs/operators';
import { of } from 'rxjs';

export const authGuard: CanActivateFn = () => {
  const http = inject(HttpClient);
  const router = inject(Router);

  return http
    .get('https://pegaespumasf.onrender.com/api/auth/check', {
      withCredentials: true, // 👈 importante para que viaje la cookie
    })
    .pipe(
      map((res: any) => {
        // Si el backend responde authenticated: true → deja entrar
        return res?.authenticated === true ? true : router.createUrlTree(['/login']);
      }),
      catchError(() => {
        // Si hay error (401, 403, etc.) → redirige a login
        return of(router.createUrlTree(['/login']));
      })
    );
};
